// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"db632dc1","239":"f3583d5e","455":"1050d6ea"}[chunkId] + ".chunk.js";
};